export default __webpack_public_path__ + "static/media/almond.7c650fce.png";